export const YUP_ERRORS_MESSAGES = {
  REQUIRED: 'This field is required',
  FILE: 'File is required',
  IMAGE: 'Image is required',
  IMAGE_SIZE: 'Please, check the image size',
  VALID_LINK: 'Please, enter valid URL',
  AFTER_NOW: 'Date must be in the future',
  NUMBRE_OR_STRING: 'Value must be string or number',
  ROLES: 'Roles are required',
  NO_SPACES_SEPARATED_BY_COMMAS: 'Enter values separated by commas without spaces',
  OBJECT_ID: 'The value must be a id',
};

export const DEFAULT_PAGE_LIMIT = 20;

export enum SpecialDropTypesEnum {
  DAILY_TASK = 'DAILY_TASK',
  SPIN_BANNER = 'SPIN_BANNER',
}

export const DEFAULT_CHUNK_SIZE = 100;

export * from './bet';
export * from './vip';
export * from './telegram-chat';
